import './style.css';

import { createApp } from 'vue';
import { createPinia, storeToRefs } from 'pinia';

import App from './App.vue';
import router from './router';
import { storeRedirectPath } from './redirect-path';
import { useUserStore } from './stores/user';
import { createDashboard } from './modules/dashboard';
import { createMetrics } from './modules/metrics';
import { useLayouts } from './layouts/layouts';
import { useComponents } from './components/components';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import VueApexCharts from "vue3-apexcharts";

async function start() {
  try {
    const app = createApp(App);
    const layouts = useLayouts();
    const components = useComponents();
    const dashboard = createDashboard();
    const metrics = createMetrics();

    app.component('FontAwesomeIcon', FontAwesomeIcon);
    app.use(createPinia());
    app.use(layouts);
    app.use(components);
    app.use(dashboard);
    app.use(metrics);
    app.use(router);
    app.use(VueApexCharts);

    library.add([
      faCircleNotch
    ]);

    const userStore = useUserStore();
    const { fetchUser, signin } = userStore;
    const { user } = storeToRefs(userStore);

    await fetchUser();

    if (user.value === null) {
      // NOTE(Dan): If you navigate directly to a URL, but are not logged in you will get sent to login and lose the URL
      //            you were trying to visit. Here, we're going to try and store then restore this on returning to the page.
      if (window.location.pathname !== null && window.location.pathname.length > 0) {
        // NOTE(Dan): If there are no matched components then the url in definitely invalid.
        //            We could also use router.resolve, but this returns a Route regardless of a proper match with a null name
        //            (all of our routes are named), either would work in theory, but using getMatchedComponents for the first
        //            version of this.
        if (router.currentRoute.value.matched.length > 0) {
          storeRedirectPath(location.pathname);
        }
      }

      await signin();
      return;
    }

    app.mount('#app');
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Error loading app', e);
    
    setTimeout(start, 5000);
  }
};

start();